import React from 'react'
import styled from "styled-components"
import List from "./list"

const Projects = () => {
    return (
      <>
        <Wrapper>
          <h2>What We Can Do</h2>
          <p>
            Now that a concept has been established, we design the rest of the
            product. We take the style formed during the conceptualization phase
            and regine it to create coherent and effective design systems. This
            stage varies, but is a result of the work done in the wireframes
            stage.
          </p>
        </Wrapper>
        <List />
      </>
    )
}

const Wrapper = styled.section`
  margin: 100px 0;
  padding: 26px 20px;
  
  h2 { font-size: 30px; line-height: 47px; } 
  p { font-size: 12px; line-height: 190%; } 
  @media screen and (min-width: 360px) { padding: 25px 57px; } 
  @media screen and (min-width: 768px) { padding: 25px 77px; } 
  @media screen and (min-width: 1024px) { margin: 100px 129px; }
  @media screen and (min-width: 1025px) {
    padding: 0;
    width: 90vw;
    margin: 100px auto;      
    max-width: 1170px;      
      h2 { font-size: 46px; line-height: 72px; } 
      p { width: 582px; font-size: 14px; line-height: 190%; text-align: justify; }
  }
  @media (min-width: 1180px) {width: 100%;}
`

export default Projects
